<template>
    <validated-field
            id="legaltexts-errors"
            :show-errors-on="showErrors" :has-any-errors="$v.toas.$invalid"
            :validation-rules="[{value: $v.toas.mandatoryAccepted, msg: $t('common.validation.legal.mandatory')}]">
        <div id="toas" class="field left aligned">

            <div class="field" v-for="(category, index) in requestedLegalTexts.consentCategories" :key="index">
                <div v-if="category.headers">
                    <label v-if="category.headers.introductionHeaderText" :class="optionalLabelClass(false)">{{ category.headers.introductionHeaderText }}</label>
                    <div v-if="category.headers.allowSelectAllCheckbox" class="select-all-checkbox">
                        <div class="ui checkbox">
                            <input type="checkbox" :id="'selectAll_' + index" v-model="category.selectAllChecked" @change="selectAllCheckboxes(category)" :class="optionalInputClass(false)">
                            <label :for="'selectAll_' + index" :class="optionalLabelClass(false)">{{ category.headers.headerTextForCheckbox }}</label>
                        </div>
                    </div>
                </div>

                <div class="field" v-for="(item, i) in category.consentItems" :key="item.id" :style="category.headers ? 'margin-left: 2rem;' : ''">
                    <div class="ui checkbox" v-if="item.consentType === 'checkbox'" :key="'checkbox_' + item.indexOfCheckbox">

                        <template>
                            <input :aria-describedby="item.consentRequired ? 'legaltexts-errors' : ''"
                                   :aria-invalid="showErrors && item.consentRequired ? 'true' : ''"
                                   :aria-required="item.consentRequired ? 'true' : ''"
                                   type="checkbox" :id="'category' + index + 'legaltext' + i" :name="'category' + index + 'legaltext' + i"
                                   v-model="acceptedLegalTexts[item.indexOfCheckbox]" @change="updateSelectAllCheckbox(category); setAriaInvalid"
                                   :class="optionalInputClass(item.consentRequired)"/>
                            <label :for="'category' + index + 'legaltext' + i"
                                   :class="optionalLabelClass(item.consentRequired)">{{item.consentText}}
                                <strong v-if="item.consentRequired"> *</strong>
                            </label>
                            <div class="ui list" style="margin-left: 2rem;">
                                <div class="item">
                                    <button type="button" class="ciam-legal-link-button" :id="'legalTextLink_' + item.id"
                                            @click.prevent="onClick(item.id, item.docType)"
                                            @keypress.enter.prevent="onClick(item.id, item.docType)"
                                            tabindex="0" v-text="item.title">
                                    </button>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div class="field" v-else-if="item.consentType === 'caption'">
                        <legal-text-box :for-element="'textbox-legaltext-' + item.indexOfCaption"
                                        :caption="item.consentText"
                                        :title="item.title"
                                        :id="item.id"
                                        :docType="item.docType"
                                        :on-click="onClick"></legal-text-box>
                    </div>
                </div>
            </div>
            <!-- Generate all modals that can be possible opened by the user -->
            <template v-for="legaltext in requestedLegalTexts.consentItemList">
                <legal-text-modal v-if="legaltext.docType === 'html'" :id="legaltext.id" ref="modals" :key="'legalTextModal-' + legaltext.id" :country="country"></legal-text-modal>
            </template>
        </div>
    </validated-field>
</template>

<script>

import LegalTextBox from './LegalTextBox'
import LegalTextModal from './LegalTextModal'
import ValidatedField from '../ValidatedField'

/* global contextPath */

export default {
  components: {
    ValidatedField,
    LegalTextModal,
    LegalTextBox
  },
  data: function () {
    return {
      // set checkboxes unchecked on init (true for checked)
      acceptedLegalTexts: Object.keys(this.requestedLegalTexts.checkboxItemList).map(() => false)
    }
  },
  validations () {
    return {
      toas: {
        mandatoryAccepted () {
          return this.areMandatoryBoxesChecked()
        }
      }
    }
  },
  props: {
    // Data for the requested legal texts
    requestedLegalTexts: { type: Object, default: () => {} },
    // If errors should be visible or not
    showErrors: { type: Boolean, default: false },
    country: String
  },
  computed: {
  },
  methods: {
    onClick: function (legalTextId, docType) {
      if (docType === 'link') {
        const url = contextPath + '/toas/legalText?documentId=' + legalTextId + '&country=' + this.country
        this.$parent.$parent.$refs.super.startLoading()
        $.get(url).done(this.openLink).fail(this.onError)
      } else {
        this.getModalBy(legalTextId).show()
      }
    },
    openLink: function (response) {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
      if (isIOS) {
        window.location.href = response.legalText
      } else {
        window.open(response.legalText, '_blank')
      }
      this.$parent.$parent.$refs.super.stopLoading()
    },
    onError: function (r) {
      console.error(r)
      $('.ui.form').form('add errors', [this.$t('errors.registration.loadLegalTexts')])
      this.$parent.$parent.$refs.super.stopLoading()
    },
    setAriaInvalid: function (event) {
      if (event.target == null) {
        return
      }
      const isChecked = event.target.checked
      event.target.setAttribute('aria-invalid', !isChecked)
    },
    getModalBy: function (legalTextId) {
      return this.$refs.modals.find(x => x.id === legalTextId)
    },
    areMandatoryBoxesChecked: function () {
      for (let i = 0; i < this.requestedLegalTexts.checkboxItemList.length; i++) {
        if (this.requestedLegalTexts.checkboxItemList[i].consentRequired && !this.acceptedLegalTexts[i]) {
          return false
        }
      }
      return true
    },
    getAcceptedIds: function () {
      const notAcceptedLegalTextIds = []

      for (let i = 0; i < this.requestedLegalTexts.checkboxItemList.length; i++) {
        if (!this.acceptedLegalTexts[i]) {
          notAcceptedLegalTextIds.push(this.requestedLegalTexts.checkboxItemList[i].id)
        }
      }

      const acceptedIdsMap = {}
      this.requestedLegalTexts.consentItemList.forEach(legalText => {
        let title = legalText.title
        let counter = 2
        if (!notAcceptedLegalTextIds.includes(legalText.id)) {
          // Check for duplicates and append a suffix if needed
          while (Object.prototype.hasOwnProperty.call(acceptedIdsMap, title)) {
            title = `${legalText.title} (${counter})`
            counter++
          }
          acceptedIdsMap[title] = legalText.id
        }
      })

      console.debug('Accepted ids map: ', acceptedIdsMap)

      return acceptedIdsMap
    },
    optionalLabelClass: function (consentRequired) {
      return consentRequired === false ? 'ciam-legal-text-label--optional' : ''
    },
    optionalInputClass: function (consentRequired) {
      return consentRequired === false ? 'ciam-legal-text-input--optional' : ''
    },
    selectAllCheckboxes: function (category) {
      const isChecked = category.selectAllChecked
      category.consentItems.forEach(item => {
        if (item.consentType === 'checkbox') {
          this.$set(this.acceptedLegalTexts, item.indexOfCheckbox, isChecked)
        }
      })
    },
    updateSelectAllCheckbox: function (category) {
      const allChecked = category.consentItems.every(item => item.consentType !== 'checkbox' || this.acceptedLegalTexts[item.indexOfCheckbox])
      category.selectAllChecked = allChecked
    }
  },
  watch: {
    $v: {
      handler (updatedValidation) {
        if (!updatedValidation.$invalid && this.showErrors) {
          this.$emit('accepted')
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
    .ui.checkbox {
        display: block;
    }
    .ui.checkbox:not(:last-child) {
        margin-bottom: 10px;
    }
    .ui.list {
        margin-left: 2.5rem;
        margin-top: 0.5rem;
    }
    .select-all-checkbox {
        margin-top: 10px;
        margin-bottom: 10px;
    }
    label {
        line-height: 20px;
        display: block;
    }
</style>
